module.exports = __webpack_public_path__ + "img/26e55c391edca1734eda330566f9810.695f025d.png";